import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'

import 'react-datepicker/dist/react-datepicker.css'

export const renderHiddenField = ({
  input,
  label,
  type,
  meta: { touched, error, warning },
}) => (
  <ReactBootstrap.Form.Group className="d-none d-sm-none d-md-none">
    <input
      className="form-control"
      {...input}
      placeholder={label}
      type={type}
    />
  </ReactBootstrap.Form.Group>
)

export const renderDisabledField = ({
  input,
  label,
  type,
  meta: { touched, error, warning },
}) => (
     <ReactBootstrap.Form.Group className={'mt-3 mb-3'}>
          <ReactBootstrap.Row>
        <ReactBootstrap.Col xs={12} md={3}>
           {label && (
        <ReactBootstrap.Form.Label>
          {label}
          {error === 'Required' ? '*' : ''}
        </ReactBootstrap.Form.Label>
      )}
        </ReactBootstrap.Col>
          <ReactBootstrap.Col xs={12} md={9}>
    <input
      disabled
      className="form-control"
      {...input}
      placeholder={label}
      type={type}
    />
          </ReactBootstrap.Col>
                <ReactBootstrap.Col className={"text-end"} xs={12}>
      {touched &&
        ((error && <span className="text-danger">{error}</span>) ||
          (warning && <span className="text-warning">{warning}</span>))}
     </ReactBootstrap.Col>
          </ReactBootstrap.Row>
  </ReactBootstrap.Form.Group>
)
